import React, { FC } from 'react';

import clsx from 'clsx';
import { Message } from 'react-hook-form';

import InputError from 'components/Inputs/InputError';

import styles from './Input.module.scss';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string | JSX.Element;
  errorMessage?: Message;
  caption?: string | JSX.Element;
  isSelect?: boolean;
  inputClassName?: string;
  inputContainerClassName?: string;
  captionClassName?: string;
  endAdornment?: () => JSX.Element;
  endAdornmentClassname?: string;
  inputRef?: React.Ref<HTMLInputElement>;
  isErrorWithoutMessage?: boolean;
  useOptionalLabel?: boolean;
}

const Input: FC<InputProps> = ({
  value,
  className,
  label,
  errorMessage,
  caption,
  inputClassName,
  inputContainerClassName,
  captionClassName,
  isSelect,
  onBlur,
  endAdornment,
  endAdornmentClassname,
  inputRef,
  isErrorWithoutMessage,
  useOptionalLabel = false,
  ...restProps
}) => (
  <div className={clsx(styles.inputContainer, className, inputContainerClassName)}>
    {label && (
      <div className={styles.label}>
        {label}
        {useOptionalLabel ? <div className={styles.optionalLabel}>{' (optional)'}</div> : ''}
      </div>
    )}
    <div className={styles.inputWithIcon}>
      <input
        ref={inputRef}
        value={value || ''}
        autoComplete="off"
        {...restProps}
        className={clsx(
          styles.input,
          isSelect && styles.selectInput,
          (!!errorMessage || isErrorWithoutMessage) && styles.errorText,
          inputClassName,
        )}
        onBlur={onBlur}
      />
      {endAdornment && <div className={endAdornmentClassname}>{endAdornment()}</div>}
    </div>
    {caption && <p className={clsx(styles.caption, captionClassName)}>{caption}</p>}
    {!!errorMessage && <InputError errorMessage={errorMessage} />}
  </div>
);

export default Input;
